import { getStaticPathFromClientOrWeb } from '~/utils/utils';

export enum VIDEO_NAMES {}

type VideoMap_Type = Record<VIDEO_NAMES | string, ReturnType<typeof getStaticPathFromClientOrWeb>>;

export const VIDEO_MAP: VideoMap_Type = {};
